// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetCockpitNotificationsListRequestViewModel from '../../viewModel/request/CockpitNotifications/GetCockpitNotificationsListRequestViewModel';
import CockpitNotificationPagingResultViewModel from '../../viewModel/resource/CockpitNotificationPagingResultViewModel';
import CockpitNotificationSetStatesRequestViewModel from '../../viewModel/resource/CockpitNotificationSetStatesRequestViewModel';
import CockpitNotificationDifferenceResourceViewModel from '../../viewModel/resource/CockpitNotificationDifferenceResourceViewModel';
import Int64LookupResourceListResultViewModel from '../../viewModel/resource/Int64LookupResourceListResultViewModel';
import CockpitNotificationStateLookupResourceListResultViewModel from '../../viewModel/resource/CockpitNotificationStateLookupResourceListResultViewModel';
import Int32LookupResourceListResultViewModel from '../../viewModel/resource/Int32LookupResourceListResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getCockpitNotificationsList(request: GetCockpitNotificationsListRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-cockpit-notifications-list'] ?? 'CockpitNotifications';
    const response = await service.get<any>(endpointPath, {
      query: {
        searchCriteria: requestDTO.searchCriteria,
        from: requestDTO.from,
        until: requestDTO.until,
        recipientId: requestDTO.recipientId,
        creatorId: requestDTO.creatorId,
        statesIds: requestDTO.statesIds,
        templateIds: requestDTO.templateIds,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new CockpitNotificationPagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async setStates(model: CockpitNotificationSetStatesRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-set-states'] ?? 'CockpitNotifications';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
  },
  /**  */
  async updateNotifications(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-notifications'] ?? 'CockpitNotifications';
    const response = await service.patch<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as boolean | undefined;
  },
  /**  */
  async getDifference(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-difference'] ?? 'CockpitNotifications/difference';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new CockpitNotificationDifferenceResourceViewModel().fromDTO(dto);
  },
  /**  */
  async getLecturersLookup(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-lecturers-lookup'] ?? 'CockpitNotifications/Lecturer/Lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new Int64LookupResourceListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getCreatorsLookup(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-creators-lookup'] ?? 'CockpitNotifications/Creator/Lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new Int64LookupResourceListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getStatesLookup(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-states-lookup'] ?? 'CockpitNotifications/State/Lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new CockpitNotificationStateLookupResourceListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getTemplateLookup(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-template-lookup'] ?? 'CockpitNotifications/Template/Lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new Int32LookupResourceListResultViewModel().fromDTO(dto);
  },
  /**  */
  async getTypeLookup(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-type-lookup'] ?? 'CockpitNotifications/Type/Lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new Int32LookupResourceListResultViewModel().fromDTO(dto);
  },
});
